import { KycApprovalStatus } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import { AcceptanceStatus } from '@dealstack/shared/lib/generated';

export const getUiApprovalState = (status?: KycApprovalStatus) => {
	if (status === AcceptanceStatus.APPROVED) {
		return AcceptanceStatus.PENDING;
	}
	return 'ACCEPT';
};
